import _objectWithoutProperties from "/vercel/path0/node_modules/next/node_modules/@babel/runtime/helpers/esm/objectWithoutProperties";
import _asyncToGenerator from "/vercel/path0/node_modules/next/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
import _classCallCheck from "/vercel/path0/node_modules/next/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/vercel/path0/node_modules/next/node_modules/@babel/runtime/helpers/esm/createClass";
import _defineProperty from "/vercel/path0/node_modules/next/node_modules/@babel/runtime/helpers/esm/defineProperty";
var _excluded = ["Authorization"];
import _regeneratorRuntime from "/vercel/path0/node_modules/next/node_modules/@babel/runtime/regenerator";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

/* eslint-disable no-underscore-dangle */

/* eslint-disable @typescript-eslint/no-shadow, no-return-await, @typescript-eslint/ban-types, @typescript-eslint/no-unused-vars */
import axios from 'axios';
import cookie from 'js-cookie';
import qs from 'qs';
import { authCookieOptions } from '../utils/auth';
import { CookieName } from '../utils/constants';

var Request = /*#__PURE__*/function () {
  function Request(baseURL) {
    var additionalHeaders = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

    _classCallCheck(this, Request);

    _defineProperty(this, "baseURL", void 0);

    _defineProperty(this, "defaultHeaders", void 0);

    _defineProperty(this, "axios", void 0);

    this.baseURL = baseURL;
    this.defaultHeaders = _objectSpread(_objectSpread({}, this.getAuthHeaders()), additionalHeaders);
    var axiosInstance = axios.create({
      baseURL: this.baseURL,
      headers: this.defaultHeaders,
      paramsSerializer: function paramsSerializer(query) {
        var queryString = qs.stringify(query);
        return queryString;
      }
    });
    axiosInstance.interceptors.response.use(function (response) {
      return response;
    }, function (error) {
      if (error.response) {
        return Promise.reject(error.response);
      } else if (error.request) {
        return Promise.reject(error.request);
      } else {
        return Promise.reject(error.message);
      }
    });
    this.axios = axiosInstance;
  }

  _createClass(Request, [{
    key: "getNewAccessToken",
    value: function () {
      var _getNewAccessToken = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(refreshToken) {
        var refreshRequest, refreshResponse, newAccessToken, newRefreshToken;
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                if (refreshToken) {
                  _context.next = 2;
                  break;
                }

                return _context.abrupt("return", null);

              case 2:
                // attempt to use refresh_token to get a new token
                refreshRequest = new Request(process.env.NEXT_PUBLIC_API_URL);
                _context.next = 5;
                return refreshRequest.postWithoutRefresh("/auth/refresh", {
                  refresh_token: refreshToken
                })["catch"](function () {
                  return void 0;
                });

              case 5:
                refreshResponse = _context.sent;
                newAccessToken = refreshResponse === null || refreshResponse === void 0 ? void 0 : refreshResponse.data.access_token;
                newRefreshToken = refreshResponse === null || refreshResponse === void 0 ? void 0 : refreshResponse.data.refresh_token;

                if (newAccessToken && newRefreshToken) {
                  cookie.set(CookieName.ACCESS_TOKEN, newAccessToken, authCookieOptions(2 * 60));
                  cookie.set(CookieName.REFRESH_TOKEN, newRefreshToken, authCookieOptions(7 * 60 * 24));

                  this._updateAuthorizationHeader(newAccessToken);
                }

                return _context.abrupt("return", newAccessToken);

              case 10:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function getNewAccessToken(_x) {
        return _getNewAccessToken.apply(this, arguments);
      }

      return getNewAccessToken;
    }()
  }, {
    key: "handleRefresh",
    value: function () {
      var _handleRefresh = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee3(op) {
        var _this = this;

        var result;
        return _regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                _context3.next = 2;
                return op()["catch"]( /*#__PURE__*/function () {
                  var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2(e) {
                    var refreshToken, accessToken;
                    return _regeneratorRuntime.wrap(function _callee2$(_context2) {
                      while (1) {
                        switch (_context2.prev = _context2.next) {
                          case 0:
                            refreshToken = cookie.get(CookieName.REFRESH_TOKEN); // if this isn't an unauth'd error or no refresh token, then rethrow

                            if (!(!refreshToken || e.status !== 401)) {
                              _context2.next = 3;
                              break;
                            }

                            throw e;

                          case 3:
                            _context2.next = 5;
                            return _this.getNewAccessToken(refreshToken);

                          case 5:
                            accessToken = _context2.sent;

                            if (accessToken) {
                              _context2.next = 8;
                              break;
                            }

                            throw e;

                          case 8:
                            return _context2.abrupt("return", op());

                          case 9:
                          case "end":
                            return _context2.stop();
                        }
                      }
                    }, _callee2);
                  }));

                  return function (_x3) {
                    return _ref.apply(this, arguments);
                  };
                }());

              case 2:
                result = _context3.sent;
                return _context3.abrupt("return", result);

              case 4:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3);
      }));

      function handleRefresh(_x2) {
        return _handleRefresh.apply(this, arguments);
      }

      return handleRefresh;
    }()
  }, {
    key: "get",
    value: function () {
      var _get = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee4(url, options) {
        var _this2 = this;

        return _regeneratorRuntime.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                this._updateAuthorizationHeader();

                return _context4.abrupt("return", this.handleRefresh(function () {
                  return _this2.axios.get(url, options);
                }));

              case 2:
              case "end":
                return _context4.stop();
            }
          }
        }, _callee4, this);
      }));

      function get(_x4, _x5) {
        return _get.apply(this, arguments);
      }

      return get;
    }()
  }, {
    key: "delete",
    value: function () {
      var _delete2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee5(url, options) {
        var _this3 = this;

        return _regeneratorRuntime.wrap(function _callee5$(_context5) {
          while (1) {
            switch (_context5.prev = _context5.next) {
              case 0:
                this._updateAuthorizationHeader();

                return _context5.abrupt("return", this.handleRefresh(function () {
                  return _this3.axios["delete"](url, options);
                }));

              case 2:
              case "end":
                return _context5.stop();
            }
          }
        }, _callee5, this);
      }));

      function _delete(_x6, _x7) {
        return _delete2.apply(this, arguments);
      }

      return _delete;
    }()
  }, {
    key: "post",
    value: function () {
      var _post = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee6(url, data, options) {
        var _this4 = this;

        return _regeneratorRuntime.wrap(function _callee6$(_context6) {
          while (1) {
            switch (_context6.prev = _context6.next) {
              case 0:
                this._updateAuthorizationHeader();

                return _context6.abrupt("return", this.handleRefresh(function () {
                  return _this4.axios.post(url, data, options);
                }));

              case 2:
              case "end":
                return _context6.stop();
            }
          }
        }, _callee6, this);
      }));

      function post(_x8, _x9, _x10) {
        return _post.apply(this, arguments);
      }

      return post;
    }()
  }, {
    key: "postWithoutRefresh",
    value: function () {
      var _postWithoutRefresh = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee7(url, data, options) {
        return _regeneratorRuntime.wrap(function _callee7$(_context7) {
          while (1) {
            switch (_context7.prev = _context7.next) {
              case 0:
                this._updateAuthorizationHeader();

                return _context7.abrupt("return", this.axios.post(url, data, options));

              case 2:
              case "end":
                return _context7.stop();
            }
          }
        }, _callee7, this);
      }));

      function postWithoutRefresh(_x11, _x12, _x13) {
        return _postWithoutRefresh.apply(this, arguments);
      }

      return postWithoutRefresh;
    }()
  }, {
    key: "put",
    value: function () {
      var _put = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee8(url, data, options) {
        var _this5 = this;

        return _regeneratorRuntime.wrap(function _callee8$(_context8) {
          while (1) {
            switch (_context8.prev = _context8.next) {
              case 0:
                this._updateAuthorizationHeader();

                return _context8.abrupt("return", this.handleRefresh(function () {
                  return _this5.axios.put(url, data, options);
                }));

              case 2:
              case "end":
                return _context8.stop();
            }
          }
        }, _callee8, this);
      }));

      function put(_x14, _x15, _x16) {
        return _put.apply(this, arguments);
      }

      return put;
    }()
  }, {
    key: "patch",
    value: function () {
      var _patch = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee9(url, data, options) {
        var _this6 = this;

        return _regeneratorRuntime.wrap(function _callee9$(_context9) {
          while (1) {
            switch (_context9.prev = _context9.next) {
              case 0:
                this._updateAuthorizationHeader();

                return _context9.abrupt("return", this.handleRefresh(function () {
                  return _this6.axios.patch(url, data, options);
                }));

              case 2:
              case "end":
                return _context9.stop();
            }
          }
        }, _callee9, this);
      }));

      function patch(_x17, _x18, _x19) {
        return _patch.apply(this, arguments);
      }

      return patch;
    }()
  }, {
    key: "removeAuthToken",
    value: function removeAuthToken() {
      var _this$axios$defaults$ = this.axios.defaults.headers,
          Authorization = _this$axios$defaults$.Authorization,
          withoutToken = _objectWithoutProperties(_this$axios$defaults$, _excluded);

      this.axios.defaults.headers = withoutToken;
    }
  }, {
    key: "updateAuthToken",
    value: function updateAuthToken(authToken) {
      delete this.axios.defaults.headers.Authorization;
      return this._updateAuthorizationHeader(authToken);
    }
  }, {
    key: "_updateAuthorizationHeader",
    value: function _updateAuthorizationHeader(authToken) {
      var token = authToken || cookie.get(CookieName.ACCESS_TOKEN);
      if (!token) return;
      var tokenHeader = {
        Authorization: "Bearer ".concat(token)
      };
      this.axios.defaults.headers = _objectSpread(_objectSpread({}, this.axios.defaults.headers), tokenHeader);
    }
  }, {
    key: "getAuthHeaders",
    value: function getAuthHeaders() {
      return {
        Accept: 'application/json',
        'X-Requested-With': 'XMLHttpRequest',
        'x-api-key': process.env.NEXT_PUBLIC_API_KEY
      };
    }
  }]);

  return Request;
}();

export var http = new Request(process.env.NEXT_PUBLIC_API_URL);